import { ArrowUpRight, MessageSquareText, ShieldAlert } from "lucide-react";
import { Link } from "react-router-dom";

import { formatRelative, ticketLabel } from "../lib/format";
import type { Ticket } from "../lib/types";
import { customerTicketPath } from "../lib/ticketLinks";
import { Avatar } from "./Avatar";
import { PriorityBadge, StatusBadge } from "./StatusBadge";

export function TicketCard({ ticket, agent = false }: { ticket: Ticket; agent?: boolean }) {
  const href = agent ? `/agent/tickets/${ticket.id}` : customerTicketPath(ticket);
  return (
    <Link className="ticket-card" to={href}>
      <div className="ticket-card__main">
        <div className="ticket-card__eyebrow">
          <span>{ticketLabel(ticket.number)}</span>
          <span aria-hidden="true">·</span>
          <span>{formatRelative(ticket.updatedAt)}</span>
          {ticket.unreadCount ? <span className="unread-dot" aria-label={`${ticket.unreadCount} unread updates`} /> : null}
        </div>
        <h3>{ticket.subject}</h3>
        <p>{ticket.lastMessagePreview || ticket.description || "No message preview available."}</p>
        <div className="ticket-card__badges">
          <StatusBadge status={ticket.status} />
          <PriorityBadge priority={ticket.priority} />
          {ticket.quarantineType === "spam" && <span className="quarantine-type-badge quarantine-type-badge--spam"><ShieldAlert aria-hidden="true" size={13} /> Spam review</span>}
          {ticket.tags?.slice(0, 2).map((tag) => <span className="tag" key={tag}>{tag}</span>)}
        </div>
      </div>
      <div className="ticket-card__aside">
        {agent && <Avatar name={ticket.requester.name} url={ticket.requester.avatarUrl} size="small" />}
        <span className="ticket-card__messages">
          <MessageSquareText aria-hidden="true" size={15} /> {ticket.messageCount ?? 0}
        </span>
        <ArrowUpRight aria-hidden="true" className="ticket-card__arrow" size={18} />
      </div>
    </Link>
  );
}
